import * as api from '@/api/give-course/test'
import * as TYPES from './type';

export default {
  //测试
  async getSKTestList({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKTestList(paramets)
    commit(TYPES.SK_TEST_LIST, { result })
    cb && cb()
  },
  //测试详情
  async getSKTestDetails({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKTestDetails(paramets)
    commit(TYPES.SK_TEST_DETAILS, { result })
    cb && cb()
  },
  //测试结束
  async putSKTestEnd({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKTestEnd(paramets)
    commit(TYPES.SK_TESTT_END, { result })
    cb && cb()
  },
  //测试推送
  async putSKTestEdit({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKTestEdit(paramets)
    commit(TYPES.SK_TESTT_EDIT, { result })
    cb && cb()
  },
}
